import React, { useState, useEffect } from 'react';

const FloatingNav = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const triggerHeight = window.innerHeight * 0.4;
      const show = window.scrollY > triggerHeight;
      setVisible(show);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigate = (e, targetId) => {
    e.preventDefault();
    document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleKeyDown = (e, targetId) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleNavigate(e, targetId);
    }
  };

  return (
    <nav className={`floating-nav ${visible ? 'visible' : ''}`} role="navigation" aria-label="Main navigation">
      <div className="nav-content">
        <div className="nav-brand">Ulrich Snyman</div>
        <div className="nav-links">
          <a href="#profile" tabIndex="0" onClick={(e) => handleNavigate(e, 'profile')} onKeyDown={(e) => handleKeyDown(e, 'profile')} aria-label="Navigate to Profile section">Profile</a>
          <a href="#projects" tabIndex="0" onClick={(e) => handleNavigate(e, 'projects')} onKeyDown={(e) => handleKeyDown(e, 'projects')} aria-label="Navigate to Projects section">Projects</a>
          <a href="#skills" tabIndex="0" onClick={(e) => handleNavigate(e, 'skills')} onKeyDown={(e) => handleKeyDown(e, 'skills')} aria-label="Navigate to Skills section">Skills</a>
        </div>
      </div>
    </nav>
  );
};

export default FloatingNav;
